module.exports = __webpack_public_path__ + "static/media/012-brightness.2691dbb7.svg";